import React from "react";
import "./index.scss";

const MainTabs = ({
  tabsTexts,
  activeTabIndex,
}) => {
  if (tabsTexts.length < 1) {
    return null;
  }
  const detectTheme = () => {
    return JSON.parse(localStorage.getItem("theme_config")) ? JSON.parse(localStorage.getItem("theme_config")).theme : "light"
  }
  return (
    <ul className="tab-container">
      {tabsTexts.map((item, index) => {
        return (
          <li
            className={`${index + 1 === activeTabIndex ? "current" : ""} ${index + 1 <= activeTabIndex ? "active" : ""} ${detectTheme()} tab-container-item`}
            key={index}
          >
            {item}
          </li>
        );
      })}
    </ul>
  );
};

export default MainTabs;
